import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import moment from 'moment'

Vue.use(Vuex)
const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.sessionStorage,
  reducer: state => ({
    user: state.user,
    isUserLoggedIn: state.isUserLoggedIn,
    noCompanyAlert: state.noCompanyAlert,
    selectionParams: state.selectionParams
  })
})

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    user: null,
    isUserLoggedIn: false,
    leftDrawer: false,
    company: null,
    noCompanyAlert: null,
    selectionParams: null,
    selectedAppointment: null
  },
  getters: {
    user: ({ user }) => {
      if (user) {
        return {
          id: user.pacienteId,
          document: user.documento,
          name: user.nombre,
          sex: user.sexo,
          dob: moment(user.fechaNacimiento).format('YYYY-MM-DD'),
          email: user.email,
          phone: user.celular,
          plan: {
            obraSocial: user.obraSocial,
            plan: user.plan
          },
          indicio: user.indicio,
          password: user.password
        }
      }
    },
    isUserLoggedIn: state => state.isUserLoggedIn,
    leftDrawer: state => state.leftDrawer,
    getCompany: state => state.company,
    getSelectionParams: state => state.selectionParams,
    getSelectedAppointment: state => state.selectedAppointment
  },
  mutations: {
    SET_USER (state, patient) {
      state.user = { ...patient }
      state.isUserLoggedIn = true
    },
    UPDATE_USER (state, { email, phone, indicio, password }) {
      state.user.email = email
      state.user.celular = phone
      state.user.indicio = indicio
      state.user.password = password
    },
    OPEN_DRAWER (state, open) {
      state.leftDrawer = open
    },
    LOGOUT_USER (state) {
      state.user = null
      state.isUserLoggedIn = false
    },
    SET_SELECTION (state, params) {
      state.selectionParams = params
    },
    SET_SELECTED_APPOINTMENT (state, appointment) {
      state.selectedAppointment = appointment
    },
    SET_COMPANY (state, company) {
      state.company = company
    },
    SET_NO_COMPANY_ALERT (state, visible) {
      state.noCompanyAlert = visible
    }
  },
  actions: {
    setUser ({ commit }, { patient }) {
      commit('SET_USER', patient)
    },
    updateUser ({ commit }, patient) {
      commit('UPDATE_USER', patient)
    },
    openDrawer ({ commit }, { open }) {
      commit('OPEN_DRAWER', open)
    },
    logoutUser ({ commit }) {
      commit('LOGOUT_USER')
    },
    setSelection ({ commit }, params) {
      commit('SET_SELECTION', params)
    },
    setSelectedAppointment ({ commit }, appointment) {
      commit('SET_SELECTED_APPOINTMENT', appointment)
    },
    setCompany ({ commit }, company) {
      commit('SET_COMPANY', company)
    },
    setNoCompanyAlert ({ commit }, visible) {
      commit('SET_NO_COMPANY_ALERT', visible)
    }
  }
})
